import * as React from 'react';
import { CharacteristicScoreDataService, SurveyVersionDataService } from '../../services';
import { CharacteristicScore, SurveyVersion } from '../../models';
import { TopNavMenu } from '../navigation/TopNavMenu';
import { TopNavMenuItem } from '../navigation/TopNavMenuItem';
import { NavLink } from 'react-router-dom';
import { DataGrid } from '../../components';
import { BaseRouteProps } from '../../interfaces';

interface CharacteristicScoreListState {
    entities: Array<CharacteristicScore>;
}

export class CharacteristicScoreListing extends React.Component<BaseRouteProps<{ id: number }>, CharacteristicScoreListState> {
    private characteristicScoreDataService = new CharacteristicScoreDataService(this.props.notificationService);
    private surveyVersionDataService = new SurveyVersionDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{ id: number }>) {
        super(props);

        this.state = {
            entities: new Array<CharacteristicScore>()
        };
    }

    public componentDidMount() {
        this.surveyVersionDataService.get(this.props.match.params.id).then((surveyVersion: SurveyVersion) => {

            this.characteristicScoreDataService.getAllBySurveyVersion(surveyVersion).then((resp: CharacteristicScore[]) => {
                this.setState(
                    { entities: resp }
                );
            });
        });
    }

    public render() {
        const listData = this.state.entities.map(entity => {
            return {
                'Characteristic': entity.characteristic.name,
                'High Score': entity.highScore,
                'LowScore': entity.lowScore,
                'ActionKey': entity.id
            };
        });

        const actionsColumn = ({ value }: any) => {
            return (
                <span className="text-right">
                    <NavLink className="btn btn-default btn-block" to={`/characteristicscore/${value}`}>Edit</NavLink>
                </span>
            );
        };

        const columnDefs = [
            { id: 'Characteristic' },
            { id: 'High Score' },
            { id: 'Low Score' },
            { id: 'ActionKey', title: 'Actions', width: '88px', customComponent: actionsColumn, sortable: false }
        ];

        return (
            <div>
                <TopNavMenu open={true}>
                    <TopNavMenuItem>
                        <NavLink to={'/surveyversion/' + this.props.match.params.id + '/characteristicscores/create'}>
                            <span className="glyphicon glyphicon-plus" />
                        </NavLink>
                    </TopNavMenuItem>
                </TopNavMenu>

                <div className="content-header">
                    <div className="content-container">
                        <NavLink to={'/surveyversion/' + this.props.match.params.id}>
                            <span className="glyphicon glyphicon-triangle-left" /> back
                        </NavLink>
                        <h1>Characteristic Scores on Survey</h1>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">
                        <DataGrid entities={listData} columns={columnDefs} />
                    </div>
                </div>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/characteristicscore/CharacteristicScoreListing.tsx